import script from "./BOMPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./BOMPopover.vue?vue&type=script&setup=true&lang=js"

import "./BOMPopover.vue?vue&type=style&index=0&id=16c78d78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c78d78"]])

export default __exports__